import React from "react";
import Input from "../input";

const Checkbox = props => {
    return(
        <div>
        <div className="form-check">
            <Input
                name={props.name}
                className="form-check-input"
                type="checkbox"
                value={props.value}
                id={props.id}
                onChange={props.onChange}
                checked={props.isChecked}
                errormessage={props.errormessage}
                hideError
            />
            <label className="form-check-label" for={props.id}>
                {props.label}
            </label>

        </div>
            {props.errormessage && <div className="message-error"><small>{props.errormessage}</small></div>}
        </div>
    )
}

export default Checkbox;
